export const VALIDATIONS_PREFIX = 'validations';

export const CLEAR_VALIDATION_ERRORS = `${VALIDATIONS_PREFIX}/CLEAR_VALIDATION_ERRORS`;
export const SET_VALIDATION_ERRORS   = `${VALIDATIONS_PREFIX}/SET_VALIDATION_ERRORS`;
export const SET_SOURCE_VISIBLE      = `${VALIDATIONS_PREFIX}/SET_SOURCE_VISIBLE`;
